module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-20-adafbd1dfa5ea0b26c86cdba0b264c87.svg";